// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__yVgmi","legacyBtn":"MutateMid_legacyBtn__3PUDB"};